/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Customization({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5 1.6A1.4 1.4 0 0 0 3.6 3v3.4h8.8V3a1.4 1.4 0 0 0-1.3-1.396V4a.6.6 0 1 1-1.2 0V1.6H8.6V3a.6.6 0 1 1-1.2 0V1.6zM5 .4A2.6 2.6 0 0 0 2.4 3v6A1.6 1.6 0 0 0 4 10.6h1.28a.4.4 0 0 1 .392.479L5.39 12.49a2.6 2.6 0 0 0 2.55 3.11h.12a2.6 2.6 0 0 0 2.55-3.11l-.282-1.412a.4.4 0 0 1 .392-.478H12A1.6 1.6 0 0 0 13.6 9V3A2.6 2.6 0 0 0 11 .4zm7.4 7.2H3.6V9c0 .22.18.4.4.4h1.28a1.6 1.6 0 0 1 1.57 1.914l-.283 1.412A1.4 1.4 0 0 0 7.94 14.4h.12a1.4 1.4 0 0 0 1.373-1.674l-.282-1.412A1.6 1.6 0 0 1 10.72 9.4H12a.4.4 0 0 0 .4-.4z" clipRule="evenodd" /></svg>;
}
;